import api from "../../app/api";

const getModules = async () => {
  try {
    const configResponse = await api.get("module/get-all.php");
    if (configResponse !== undefined && configResponse.data !== undefined) {
      return configResponse.data?.data;
    }
    return Promise.reject("Cannot get the modules");
  } catch (e) {
    return Promise.reject("Cannot get the modules");
  }
};

const getTrendsData = async (moduleId: number) => {
  try {
    const configResponse = await api.get(`/dashboard/trends.php/${moduleId}`);
    if (configResponse !== undefined && configResponse.data) {
      return configResponse.data;
    }
    return Promise.reject("Cannot get the modules");
  } catch (e) {
    console.error(e);
    return Promise.reject("Cannot get the modules");
  }
};
const getModuleStatus = async (moduleId: number) => {
  try {
    const response = await api.get(`/dashboard/get-diagnostic-status.php/${moduleId}`);
    if (response !== undefined && response.data) {
      return response.data;
    }
    return Promise.reject("Cannot get module status");
  } catch (e) {
    console.error(e);
    return Promise.reject("Cannot get module status");
  }
};

const getAuxiliaryTrendRows = async (payload: any) => {
  try {
    const response = await api.post("/trend/get-all.php", payload);
    if (response !== undefined && response.data !== undefined) {
      return response.data?.data || [];
    }
    return Promise.reject({ Message: "Cannot get auxiliary trend data" });
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
};

const DashboardApi = {
  getModules,
  getTrendsData,
  getModuleStatus,
  getAuxiliaryTrendRows
};

export default DashboardApi;
